import dayjs from 'dayjs';
import axios from "axios";
import * as XLSX from 'xlsx';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import 'dayjs/locale/de';
import 'dayjs/locale/nl';
import 'dayjs/locale/it';
import 'dayjs/locale/es';
import 'dayjs/locale/pt';
import { fr, enGB, it, es, nl, de, pt } from 'date-fns/locale';
import i18n from '/i18n-init.js';

export const getDateFnsLocale = (locale = null) => {
    switch(locale ?? ENV.lang) {
        case 'en_GB':
            return enGB;
        case 'fr_FR':
            return fr;
        case 'de_DE':
            return de;
        case 'it_IT':
            return it;
        case 'nl_NL':
            return nl;
        case 'pt_PT':
            return pt;
        case 'es_ES':
            return es;
    }
}

const locale_dayjs = (ENV.lang.split('_'))[0];
dayjs.extend(localizedFormat);
dayjs.locale(locale_dayjs);

var originalFetch = window.fetch;
window.fetch = function (input, init) {
    if (!init) {
        init = {};
    }
    if (!init.headers) {
        init.headers = new Headers();
    }

    // init.headers could be: 
    //   `A Headers object, an object literal, 
    //    or an array of two-item arrays to set request’s headers.`
    if (init.headers instanceof Headers) {
        init.headers.append('X-REQUESTED-WITH', 'xmlhttprequest');
    } else if (init.headers instanceof Array) {
        init.headers.push(['X-REQUESTED-WITH', 'xmlhttprequest']);
    } else {
        // object ?
        init.headers['X-REQUESTED-WITH'] = 'xmlhttprequest';
    }
    return originalFetch(input, init);
};

axios.interceptors.request.use(function (config) {
    config.headers['X-REQUESTED-WITH'] =  'xmlhttprequest';
    return config;
});

/**
 * Test if an object is empty
 * @param {object} obj
 * @return {boolean}
 */
export const isEmptyObject = (obj) => (
    Object.keys(obj).length === 0
);

/**
 * Truncate a string depending on length
 * @param {string} string string to truncate
 * @param {int} strLength number of string characters
 * @param {string} ellipsis the text ellipsis appened at the end of the string
 * @return {string}
 */
export const truncateString = (string, strLength, ellipsis = '...') => {
    if (string.length <= strLength) {
        return string
    }
    return string.slice(0, strLength) + ellipsis;
}

/**
 * Copy text to clipboard
 */
export function copyTextToClipboard(e, value) {
    var textToCopy = value;
    const gctrad = i18n.t;

    if (navigator.clipboard && window.isSecureContext) {
        return new Promise((res, rej) => {
            // navigator clipboard api method'
            navigator.clipboard.writeText(textToCopy)
            res();
        })
            .then(nav.infos(gctrad('Texte copié dans le presse-papier')));
    } else {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
            // here the magic happens
            document.execCommand('copy') ? res() : rej();
            textArea.remove();
            $('.js-infos-container').remove();
        })
            .then(nav.infos(gctrad('Texte copié dans le presse-papier')));
    }
}

/**
 * Persist a state to HTML5 storage.
 * @param {string} storageKey
 * @param {object} state
 * @param {boolean} init
 * @return {object} The state persisted
 */
export function persistStateToSession(storageKey, state, init = false) {
    const storageType = window.sessionStorage;
    const storage = storageType.getItem(storageKey);
    let persistedState = null;

    if (typeof state === 'object' && Object.keys(state).length !== 0) {
        if (!storage || !init) {
            storageType.setItem(storageKey, JSON.stringify(state));
            persistedState = state;
        } else {
            persistedState = JSON.parse(storage);
        }
    }
    else storageType.removeItem(storageKey);

    return persistedState;
}

/**
 * get random int between 2 values
 * @param {int} min
 * @param {int} max
 */
export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
}

/**
 * A UILISER POUR LES KPIS RECUPERES VIA L'API
 * @param {array} kpi_data Données KPI issues des requêtes formatKpiByCurrency (client / companies) pour l'affichage des KPI client et entreprises
 * @returns {array}
 */
export function newFormatKpiData(kpi_data, byRequests = false) {

    const gctrad = i18n.t;
    let selectedCurrency = typeof arguments[1] != 'undefined' && arguments[1] != '' ? arguments[1] : null;
    let formattedKpiData = [];

    if(kpi_data){
        if ( typeof(kpi_data['hydra:member']) != 'undefined' ) {
            kpi_data = kpi_data['hydra:member'];
        }    
        
        if (kpi_data.length == 0) {
            formattedKpiData.push({
                items: [
                    {
                        iconClass: 'fa-regular fa-folder-open',
                        text: byRequests ? i18n.t('Demande') : i18n.t('Dossiers'),
                        value: 0
                    }
                ]
            });
            return formattedKpiData;
        }
    
        for (let i in kpi_data) {
            let data = {
                devise_iso: kpi_data[i].currency?.code_iso,
                items: [
                    {
                        iconClass: 'fa-regular fa-folder-open',
                        text: byRequests ? i18n.t('Demandes') : i18n.t('Dossiers'),
                        value: byRequests ? kpi_data[i].totalRequests : kpi_data[i].totalRequestsHotels
                    },
                    {
                        iconClass: 'fa-regular fa-money-bill-wave',
                        text: gctrad('de CA'),
                        value: kpi_data[i].totalTurnover.formatMoney(kpi_data[i].currency?.code_iso)
                    },
                    {
                        iconClass: 'fa-regular fa-chart-simple',
                        text: gctrad('de résa'),
                        value: kpi_data[i].bookedRate + '%'
                    }
                ]
            };
            // Si une devise est sélectionnée, on met les chiffres pour cette devise en premier
            if (selectedCurrency != null && selectedCurrency == kpi_data[i].currency?.code_iso) {
                formattedKpiData.unshift(data);
            }
            else {
                formattedKpiData.push(data);
            }
        }        
    }

    return formattedKpiData;
}

/**
 * 
 * @param {array} kpi_data Données KPI issues des requêtes formatKpiByCurrency (client / companies) pour l'affichage des KPI client et entreprises
 * @returns {array}
 */
export function formatKpiData(kpi_data) {
    const gctrad = i18n.t;
    let selectedCurrency = typeof arguments[1] != 'undefined' && arguments[1] != '' ? arguments[1] : null;
    let formattedKpiData = [];

    if (kpi_data.length == 0) {
        formattedKpiData.push({
            items: [
                {
                    iconClass: 'fa-regular fa-folder-open',
                    text: i18n.t('Dossiers'),
                    value: 0
                }
            ]
        });
        return formattedKpiData;
    }

    for (let i in kpi_data) {
        let data = {
            devise_iso: kpi_data[i].devises_code_iso,
            items: [
                {
                    iconClass: 'fa-regular fa-folder-open',
                    text: gctrad('Dossiers'),
                    value: kpi_data[i].total_requests_hotels
                },
                {
                    iconClass: 'fa-regular fa-money-bill-wave',
                    text: gctrad('de CA'),
                    value: kpi_data[i].booked_volume.formatMoney(kpi_data[i].devises_code_iso)
                },
                {
                    iconClass: 'fa-regular fa-chart-simple',
                    text: gctrad('de résa'),
                    value: kpi_data[i].booked_rate + '%'
                }
            ]
        };
        // Si une devise est sélectionnée, on met les chiffres pour cette devise en premier
        if (selectedCurrency != null && selectedCurrency == kpi_data[i].devises_code_iso) {
            formattedKpiData.unshift(data);
        }
        else {
            formattedKpiData.push(data);
        }
    }

    return formattedKpiData;
}

/** Change XLSX worksheet columns format
  * @param {object} worksheet
  * @param {object} columns: object with key 0-indexed column you want to change and value the column type (https://docs.sheetjs.com/docs/csf/cell)
  * @param {string} number_format: number ECMA-376 format string (https://docs.sheetjs.com/docs/csf/features/nf#miscellany)
  * @return {object} modified worksheet object
*/
export function setXlsxColumnFormat(worksheet, columns, number_format = '#,##0.00') {
    for (const [column, type] of Object.entries(columns)) {
        //let C = XLSX.utils.decode_col(column);
        let C = Number(column);
        let range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let i = range.s.r + 1; i <= range.e.r; ++i) {
            /* find the data cell (range.s.r + 1 skips the header row of the worksheet) */
            var ref = XLSX.utils.encode_cell({ r: i, c: C });
            /* if the particular row did not contain data for the column, the cell will not be generated */
            if (!worksheet[ref]) continue;
            worksheet[ref].t = type;
            if (type != 'n') continue;
            worksheet[ref].z = number_format;
        }
    }
    return worksheet;
}

/** Export data to XLSX file
  * @param {string} filename
  * @param {array} exportData
  * @param {object} columnFormat
*/
export function exportXlsx(filename, exportData, columnFormat) {
    const title = formatXlsExportFilename(currentSociete.nom, filename);
    let worksheet_title_str = title.split('-').slice(-1).toString();
    const worksheet_title = truncateString(worksheet_title_str, 31, ''); // Max 31 characters !
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    if (Object.keys(columnFormat.date_with_hours ?? {}).length) {
        setXlsxColumnFormat(worksheet, columnFormat.date_with_hours, getDateFormatString(true));  // date with hours
    }
    if (Object.keys(columnFormat.date_only ?? {}).length) {
        setXlsxColumnFormat(worksheet, columnFormat.date_only, getDateFormatString());  // date only
    }
    if (Object.keys(columnFormat.int ?? {}).length) {
        setXlsxColumnFormat(worksheet, columnFormat.int, '0');  // int
    }
    if (Object.keys(columnFormat.float).length ?? {}) {
        setXlsxColumnFormat(worksheet, columnFormat.float);  // float
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, worksheet_title);
    XLSX.writeFile(workbook, title + ".xlsx");
}

export function importAutoMatchColumn(dataImport, dataSrc, dataFields, fieldName, options = [], fieldMatch = 'value', type = 'string') {

    let first = dataImport[0];
    if (!first.hasOwnProperty(fieldName)) {
        return dataImport;
    }

    let field = (dataFields.filter((field) => {
        return field.value == fieldName;
    }))[0];
    let valides = [];
    if (options.length > 0) {
        options.map((elt) => {
            valides.push(elt[fieldMatch]);
        });
    }

    dataImport.map((row, ind) => {
        let src = null;
        switch (type) {
            case 'float':
                src = typeof dataSrc[ind][field.index] != 'undefined' ? parseFloat((dataSrc[ind][field.index]).replace(',', '.')) : null;
                break;

            case 'int':
                src = typeof dataSrc[ind][field.index] != 'undefined' ? parseInt(dataSrc[ind][field.index]) : null;
                break;

            default:
                src = (dataSrc[ind][field.index]) ?? null;
                break;
        }

        if (options.length == 0 || valides.includes(src)) {
            if (fieldMatch == 'value') {
                row[fieldName] = src;
            } else {
                let match = options.filter((opt) => {
                    return opt[fieldMatch] == src
                });

                if (match.length > 0) {
                    row[fieldName] = match[0].value;
                }
            }
        }
    })
    return dataImport;
}

export function importAutoMatchCheckboxes(dataImport, dataSrc, dataFields) {
    let checkboxes = [];
    dataFields.map((field) => {
        if (field.type == 3) {
            checkboxes.push(field);
        }
    });
    dataImport.map((row, ind) => {
        checkboxes.map((field) => {
            let src = (dataSrc[ind][field.index]) ?? null;
            if (src === '1') {
                row[field.value] = true;
            }
        })
    });
    return dataImport;
}

export function selectedValuesToArray(selectedValues) {
    let selectFields = arguments[1] ?? 'value';
    let values = [];
    for (let i in selectedValues) {
        if ( (selectedValues[i].isGroup ?? false) && selectedValues[i][selectFields].indexOf(',') !== -1 ) {
            let selectedSubValues = selectedValues[i][selectFields].split(',');
            selectedSubValues.map((ee, ii) => {
                values.push(ee);
            })
        }
        else if ( (selectedValues[i].isGroup ?? false) && typeof selectedValues[i].value == 'object' ) {
            selectedValues[i].value.map((ee, ii) => {
                values.push(ee);
            })
        }
        else {
            values.push(selectedValues[i][selectFields]);
        }
    }
    return values;
}

/**
 * Format to locale abbreviate currency number
 * @param {float|int} value
 * @param {string|null} currency currency code (default null = no display of the currency symbol)
 * @param {int|null} digits number of max digits (default 1)
 * @param {bool|null} no_abbreviate if true return the full value
 * @return {string|null} formatted number or null
 */
export function salesNumberFormat(value, currency = null, digits = 1, no_abbreviate = false) {
    if (!isNaN(Number(value))) {
        const options = {
            minimumFractionDigits: 0,
            maximumFractionDigits: digits
        };
        if (!no_abbreviate) {
            options.notation = 'compact';
        }
        if (currency) {
            options.style = 'currency';
            options.currency = currency;
        }
        return Intl.NumberFormat(ENV.lang.replace('_', '-'), options)
            ?.format(value).replace(/^(\D+)/, '$1 ')
            .replace(/\s+/, '')
            ?? null
        ;
    }
    return null;
}

/**
 * Generate hexadecimal color code
 * @return {string} hexadecimal color code
 */
export function generateHexaRandomColor() {
    let letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

/**
 * Convert hexadecimal to rgba color
 * @param {string} hexa hexadecimal color code
 * @param {float} alpha optional transparency
 */
export function hexaToRgbaColor(hexa, alpha = 1) {
    let color;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hexa)) {
        color = hexa.substring(1).split('');
        if (color.length === 3) {
            color = [color[0], color[0], color[1], color[1], color[2], color[2]];
        }
        color = '0x' + color.join('');
        return 'rgba(' + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(',') + ',' + alpha + ')';
    }
    throw new Error('Bad Hex');
}

/**
 * Generate a Unique ID
 * @return {string}
 */
export function uniqueId() {
    return Math.floor(Math.random() * 100000000);
}

/**
 * Calculate percent of change between two numbers
 * @param {float|int} number1
 * @param {float|int} number2
 * @param {boolean} rawValue return full value
 * @return {int} % of change
 */
export function calcPercentChange(number1, number2, rawValue = false) {
    if (number1 === 0 && number2 === 0) return 0;
    if (number2 == 0) {
        number2++;
        number1++;
    }
    const change = ((number1 - number2) / number2) * 100;
    return rawValue ? change : Math.round(change);
}

/**
 * Format chartJs axis label if longer that max lenght
 * @param {string} label
 * @param {int} maxLenght
 * @return {string} the formatted label
 */
export function formatChartLabel(label, maxLenght) {
    let sections = [];
    let words = label.split(" ");
    let temp = "";

    words.forEach((item, index) => {
        if (temp.length > 0) {
            let concat = temp + ' ' + item;
            if (concat.length > maxLenght) {
                sections.push(temp);
                temp = "";
            }
            else {
                if (index == (words.length - 1)) {
                    sections.push(concat);
                    return;
                }
                else {
                    temp = concat;
                    return;
                }
            }
        }
        if (index == (words.length - 1)) {
            sections.push(item);
            return;
        }
        if (item.length < maxLenght) {
            temp = item;
        }
        else {
            sections.push(item);
        }

    });

    return sections;
}

/**
 * Uppercase the first letter of each word in a string
 * @param {string} strt
 * @return {string} the formatted str
 */
export function titleCase(str) {
    let splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
}

/**
 * Return a date range (in sql format) to human readable string
 * @param {string|null} startDate
 * @param {string|null} endDate
 * @return {string|null}
 */
export function displayHumanReadableDateRange(startDate, endDate) {
    if (startDate != '' && endDate != '') {
        const dateStart = dayjs(String(startDate));
        const dateEnd = dayjs(String(endDate));

        if (!isNaN(dateStart?.$y) && !isNaN(dateEnd?.$y)) {
            const currentYear = (dateStart.$y === dateEnd.$y) ? dateStart.$y : null;
            let range = dateStart.format(currentYear ? 'DD MMM' : 'DD MMM YYYY');
            range += ' - ' + dateEnd.format('DD MMM YYYY');
            return titleCase(range);
        }
    }
    return null;
}

/**
 * Return a string as an iban format (space every 4 chars)
 * @param {string|null} string
 */
export function formatIban(string){
    if ( string == null ) return '';
    return string.replace(/[^\dA-Z\*]/g, '').replace(/(.{4})/g, '$1 ').trim();
}

/**
 * Return the human readable request ref
 * @param {int} requests_id
 */
export function displayRequestRef(requests_id) {
    return 'BY-'.concat(requests_id);
}

/**
 * Converts an object into a URL query string.
 * 
 * @param {Object} params - The parameters object where keys are parameter names and values are parameter values.
 *                          Values can be strings, numbers, or arrays of strings/numbers.
 * @returns {String} The query string without the leading '?'.
 */
function paramsToQueryString(params) {
    const parts = [];

    const formatDate = (date) => {
        if (Object.prototype.toString.call(date) === '[object Date]') {
            return date.toISOString().split('T')[0]; // Format date to YYYY-MM-DD
        }
        return date;
    };

    Object.keys(params).forEach(key => {
        const value = params[key];
        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                const formattedItem = formatDate(item);
                parts.push(`${encodeURIComponent(key)}[${index}]=${encodeURIComponent(formattedItem)}`);
            });
        } else if (value !== undefined && value !== null) {
            const formattedValue = formatDate(value);
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(formattedValue)}`);
        }
    });

    return parts.join('&');
}

export { paramsToQueryString };

/**
 * Move an array item to a different position
 * Moves the item to the new position in the array.
 * @param {array} array
 * @param {int} fromIndex
 * @param {int} toIndex
 */
export function arrayMoveMutable(array, fromIndex, toIndex) {
	const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

	if (startIndex >= 0 && startIndex < array.length) {
		const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

		const [item] = array.splice(fromIndex, 1);
		array.splice(endIndex, 0, item);
	}
}

/**
 * Move an array item to a different position
 * Clones the given array, moves the item to a new position in the new array, and then returns the new array. The given array is not mutated.
 * @param {array} array
 * @param {int} fromIndex
 * @param {int} toIndex
 */
export function arrayMoveImmutable(array, fromIndex, toIndex) {
	const newArray = [...array];
	arrayMoveMutable(newArray, fromIndex, toIndex);
	return newArray;
}

/** Transforms a country code to a country flag emoji.
 * @param {string} countryCode - The ISO 3166-1 alpha-2 country code.
 * @returns {string} The corresponding country flag emoji.
 */
export function countryCodeToFlagEmoji(countryCode) {
    // Ensure the country code is uppercase
    const upperCaseCountryCode = countryCode.toUpperCase();

    // Validate that the country code is exactly 2 letters
    if (upperCaseCountryCode.length !== 2 || !/^[A-Z]{2}$/.test(upperCaseCountryCode)) {
        throw new Error('Invalid country code');
    }

    // Convert country code letters to regional indicator symbols
    const offset = 0x1F1E6 - 'A'.charCodeAt(0);
    const firstChar = String.fromCodePoint(upperCaseCountryCode.charCodeAt(0) + offset);
    const secondChar = String.fromCodePoint(upperCaseCountryCode.charCodeAt(1) + offset);

    return firstChar + secondChar;
}

export function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}

export const selectDateFilterDefaultRangeTypes = [
    {
        'value': 'today',
        'label': '[:new-front] Aujourdhui'
    },
    {
        'value': 'tomorrow',
        'label': '[:new-front] Demain'
    },
    {
        'value': 'this_week',
        'label': '[:new-front] Cette semaine'
    },
    {
        'value': 'next_week',
        'label': '[:new-front] Semaine prochaine'
    },
    {
        'value': 'this_month',
        'label': '[:new-front] Ce mois'
    },
    {
        'value': 'next_month',
        'label': '[:new-front] Mois prochain'
    },
    {
        'value': 'custom',
        'label': 'Dates personnalisées'
    }
];

export const dashboardCategoriesDefault = [
    {
        slug: 'active',
        label: '[:requests_category] active'
    },
    {
        slug: 'closed',
        label: '[:requests_category] closed'
    },
    {
        slug: 'all',
        label: '[:requests_category] all'
    }
];